<template>
  <div class="header">
    <div class="left">
      <button v-if="!fromQR" @click="backButtonClicked" class="button-back">
        <img :src="require(`@/assets/img/icon/svg/button-back.svg`)" />
      </button>
    </div>

    <div class="center" style="overflow: hidden; height: 1rem">
      <span class="title">{{ headerTitle }}</span>
    </div>

    <div class="right">
      <button
        v-if="fromQR"
        @click="closeButtonClicked"
        class="button-close"
      ></button>
      <div class="space" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TheHeader",

  props: {
    headerTitle: {
      type: String,
      required: false,
    },
    clickBackButtonEvent: {
      type: Function,
      required: false,
      default: null,
    },
  },
  mounted() {
    if (this.$route.query.fromQR && this.$route.query.type != "mamoru") {
      this.fromQR = true;
    }
  },

  data() {
    return {
      fromQR: false,
    };
  },
  computed: {},
  methods: {
    backButtonClicked() {
      if (this.clickBackButtonEvent) {
        this.clickBackButtonEvent();
      } else if (this.$route.query.qrFailed) {
        //redirect from scan QR failed cannot use history_back
        this.$router.push({
          name: "Sheet",
          params: {
            book_group_id: this.$route.params.book_group_id,
            master_sheet_id: this.$store.getters["ticketing/masterSheet"].id,
            sheet_id: this.$route.params.sheet_id,
          },
        });
      } else {
        this.backToPreviousPage();
      }
    },
    closeButtonClicked() {
      this.returnNativeApp();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  z-index: 99;
  padding: 5px 11px;
  height: var(--navigation-height);
  background-color: rgba(0, 0, 0, 0%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background-color: #fff;
  transition: all 0.3s;

  .left {
    width: 10%;
    .back-button {
      display: block;
      width: 28px;
      height: 28px;
      background-image: url("~@/assets/img//arrow/svg/arrow-left-blue-14px.svg");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }
  }

  .center {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 1rem;
    text-align: center;
    padding-top: calc(env(safe-area-inset-top, 30px) + 60px) !important;

    .title {
      font: inherit;
      font-size: 1rem;
      font-weight: bold;
    }
  }

  .right {
    button.button-close {
      position: relative;
      top: 30px;
      float: right;
      right: 10px;
      width: 26px;
      height: 26px;
      border: none;
      border-radius: 50%;
      background-color: transparent;
      background-image: url("~@/assets/img/icon/svg/button-close.svg");
      background-size: 26px 26px;
      box-shadow: var(--defaultBoxShadow);
    }
    .space {
      width: 28px;
      height: 28px;
    }
  }
}
</style>
